import { defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,
  production: true,
  mceApiUrl: "https://api.mycableengineering.com",
};
